<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroNumero="filtroNumero"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :cliente="cliente"
          :contacto="contacto"
          :numero="numero"
          :accion="accion"
          :numeroPO="numeroPO"
          :sortByDescending="sortByDescending"
          :opcionOrdenPresupuestosCertificadosFacturados="false"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Presupuestos Cancelados">
          <app-presupuestos-cancelados
            :presupuestos="presupuestos"
            :tableBusy="tableBusy"
            :vistaPresupuestos="vistaPresupuestosCancelados"
            :paginaActual="paginaActual"
            :registrosPorPagina="registrosPorPagina"
            :totalPaginas="totalPaginas"
            :totalRegistros="totalRegistros"
            :opcionRestablecerPresupuesto="opcionRestablecerPresupuesto"
            @consultarPresupuesto="consultar"
            @actualizarPresupuestos="getPresupuestos"
            @restablecerPresupuesto="restablecerPresupuesto">
          </app-presupuestos-cancelados>  
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltroCancelados.vue';
import PresupuestosCancelados from './listPresupuestos.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestosinternoscancelados/getField',
  mutationType: 'presupuestosinternoscancelados/updateField',
});

export default {
  name: 'PresupuestosInternosCancelados',
  components: {
    appFiltro: Filtro,
    appPresupuestosCancelados: PresupuestosCancelados,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      tableBusy: false,
      opcionRestablecerPresupuesto: false
    }
  },
  computed: {
    ...mapFields([
      'presupuestos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',

      'filtroNumero',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'contacto',
      'numero',
      'accion',
      'numeroPO',
      'sortByDescending',

      'vistaPresupuestosCancelados',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.opcionRestablecerPresupuesto = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosRestablecer'));

    this.getPresupuestos();
  },  
  methods: {
    filtrar(filtro) {
      this.filtroNumero = filtro.filtroNumero;
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.cliente = filtro.cliente;
      this.contacto = filtro.contacto;
      this.numero = parseInt(filtro.numero);
      this.accion = filtro.accion;
      this.numeroPO = filtro.numeroPO;
      this.sortByDescending = filtro.sortByDescending;
      this.sortByFechaCierreEstimado = filtro.sortByFechaCierreEstimado;
      this.paginaActual = 1;
      
      this.getPresupuestos();
    },
    getPresupuestos() {
      this.tableBusy = true;
      this.$store.dispatch('presupuestosinternoscancelados/getPresupuestos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultar (item) {
      this.$router.push({ name: 'PresupuestoInternoData', 
                          params: { id: item.id }});
    },
    restablecerPresupuesto(item) {
      this.showModalConfirm('¿Desea restablecer el presupuesto seleccionado?', 
        this.restablecer.bind(this, item.id), 'Si', 
        null, 'No');
    },
    restablecer(presupuestoInternoId) {
      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/restablecerPresupuesto', presupuestoInternoId)
        .then(() => {
          this.showModalMsj('El presupuesto se restableció con éxito', null, null, 'light');
          this.getPresupuestos();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if (newVal != 0 && oldVal != 0) {
        this.getPresupuestos();
      }
    },    
  }    
}
</script>

<style>
</style>
